"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rugged = void 0;
const IAward_1 = require("./../IAward");
const TileType_1 = require("../../TileType");
class Rugged {
    constructor() {
        this.name = 'Rugged';
        this.description = 'Have the most tiles adjacent to hazards';
    }
    getScore(player) {
        let score = player.game.board.spaces.filter((space) => space.player === player &&
            space.tile !== undefined &&
            TileType_1.isAresTile(space.tile.tileType) === false &&
            player.game.board.getAdjacentSpaces(space).some((space) => space.tile !== undefined && TileType_1.isAresTile(space.tile.tileType))).length;
        return score + IAward_1.getAdditionalScore(player);
    }
}
exports.Rugged = Rugged;
//# sourceMappingURL=Rugged.js.map